module.exports = __webpack_public_path__ + "img/gray.bdb077de.svg";